import { render, staticRenderFns } from "./DnBeam.vue?vue&type=template&id=a1f2c5b2&scoped=true&"
import script from "./DnBeam.vue?vue&type=script&lang=js&"
export * from "./DnBeam.vue?vue&type=script&lang=js&"
import style0 from "./DnBeam.vue?vue&type=style&index=0&id=a1f2c5b2&scoped=true&lang=scss&"
import style1 from "./DnBeam.vue?vue&type=style&index=1&id=a1f2c5b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f2c5b2",
  null
  
)

export default component.exports